import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import {
    Button,
    Card,
    Col,
    Container,
    Dropdown,
    Form,
    Image,
    Row,
    Table,
} from "react-bootstrap";
import { Image_Up, Man } from "../../../../../assets/images";
import * as Constants from "../../../../Helper/constants/constants";
import Select from "react-select";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";

const ProfileLab = () => {
    return (
        <div className="add_staff_section profile_lab_area">
            <WithoutImageHeader
                header={Constants.PROFILE_LAB}
                lefticon={'menu'}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="add_staff_area">
                            <div className="image_section">
                                <div className="img_area">
                                    <Image src={Man} alt="..." />
                                </div>
                                <div className="gallery_img">
                                    <Image src={Image_Up} alt="..." />
                                </div>
                            </div>

                            <div className="form_area">
                                <Form>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Full Name<span>*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter your full name"
                                            value={'Harjinder Singh'}
                                        />
                                    </Form.Group>
                                    <Row>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                                            <Form>
                                                <Form.Group className="form-group">
                                                    <Form.Label>
                                                        Contact Number<span>*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter"
                                                        value={'+91-7987987987'}
                                                    />
                                                </Form.Group>
                                            </Form>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                                            <Form.Group className="form-group">
                                                <Form.Label>
                                                    UH Id*<span>*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="7DH5738H"
                                                    value={'7DH5738H'}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                                            <Form>
                                                <Form.Group className="form-group">
                                                    <Form.Label>
                                                        Email
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter your Email"
                                                        value={'harjinder12@gmail.com'}
                                                    />
                                                </Form.Group>
                                            </Form>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                                            <Form>
                                                <Form.Group className="form-group">
                                                    <Form.Label>
                                                        Registration<span>*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="104578"
                                                        value={'104578'}
                                                    />
                                                </Form.Group>
                                            </Form>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                                            <div className="dropdown_box">
                                                <h6>
                                                    Specialization<span>*</span>
                                                </h6>
                                                <div className="dropdown_area">
                                                    <Select
                                                        autoFocus={false}
                                                        placeholder={
                                                            "Viralogist"
                                                        }
                                                        options={''}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col
                                            xxl={6}
                                            xl={6}
                                            lg={6}
                                            md={6}
                                            sm={12}
                                            xs={12}
                                        >
                                            <Form>
                                                <Form.Group className="form-group">
                                                    <Form.Label>
                                                        Practicing tenure
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="4"
                                                        value={'4'}
                                                    />
                                                </Form.Group>
                                            </Form>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                            <Form>
                                                <Form.Group className="form-group">
                                                    <Form.Label>
                                                        Date of Birth
                                                        <span>*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        placeholder="DD/MM/YYYY"

                                                    />
                                                </Form.Group>
                                            </Form>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                                            <div className="dropdown_box">
                                                <h6>
                                                    Gender<span>*</span>
                                                </h6>
                                                <div className="dropdown_area">
                                                    <Select
                                                        autoFocus={false}
                                                        placeholder={
                                                            "Male"
                                                        }
                                                        options={''}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12}>
                                            <div className="dropdown_box">
                                                <h6>
                                                    Blood Group<span>*</span>
                                                </h6>
                                                <div className="dropdown_area">
                                                    <Select
                                                        autoFocus={false}
                                                        placeholder={
                                                            "AB+"
                                                        }
                                                        options={''}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Address
                                            <span>*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="date"
                                            placeholder="Type here"

                                        />
                                    </Form.Group>
                                    <Row>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                                            <div className="dropdown_box">
                                                <h6>
                                                    City<span>*</span>
                                                </h6>
                                                <div className="dropdown_area">
                                                    <Select
                                                        placeholder={
                                                            "Select"
                                                        }
                                                        options={''}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col
                                            xxl={6}
                                            xl={6}
                                            lg={6}
                                            md={6}
                                            sm={12}
                                            xs={12}
                                        >
                                            <div className="dropdown_box">
                                                <h6>
                                                    State<span>*</span>
                                                </h6>
                                                <div className="dropdown_area">
                                                    <Select
                                                        placeholder={
                                                            "Select"
                                                        }
                                                        options={''}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                                <div>
                                    <div className="btn_area">
                                        <Button className="cancelBtn" type="button">
                                            Cancel
                                        </Button>
                                        <Button
                                            className="submitBtn"
                                            type="submit"
                                        >
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ProfileLab;
